import * as React from "react";
import * as Immutable from "immutable";
import { Link } from "components/common";
import RolesCell from "components/permissions/RolesCell";
import SecurityRoutes from "security/Routes";
import UsersCell from "security/components/teams-overview/UsersCell";
const SyncedTeamsOverviewItem = ({
  team,
  team: { id, name, roles: teamsRolesIds },
  rolesContext = Immutable.Map(),
  usersContext = Immutable.Map()
}) => {
  const teamRolesNames = teamsRolesIds.map((roleId) => {
    var _a, _b;
    return (_b = (_a = rolesContext.get(roleId)) == null ? void 0 : _a.title) != null ? _b : `${roleId} (Name not found)`;
  }).toSet();
  return /* @__PURE__ */ React.createElement("tr", { key: id }, /* @__PURE__ */ React.createElement("td", { className: "limited" }, /* @__PURE__ */ React.createElement(Link, { to: SecurityRoutes.TEAMS.DETAILS(id) }, name)), /* @__PURE__ */ React.createElement(UsersCell, { team, usersContext }), /* @__PURE__ */ React.createElement(RolesCell, { roles: teamRolesNames }));
};
export default SyncedTeamsOverviewItem;
